import React, { useMemo } from 'react';

interface FloatingNodesProps {
  className?: string;
  count?: number;
}

export const FloatingNodes: React.FC<FloatingNodesProps> = ({
  className = '',
  count = 6,
}) => {
  const nodes = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        size: 20 + Math.random() * 40,
        x: 10 + Math.random() * 80,
        y: 10 + Math.random() * 80,
        delay: i * 0.5,
        duration: 4 + Math.random() * 4,
        opacity: 0.1 + Math.random() * 0.2,
      })),
    [count]
  );

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {nodes.map((node) => (
        <div
          key={node.id}
          className="absolute rounded-full border border-apple-blue/30"
          style={{
            width: node.size,
            height: node.size,
            left: `${node.x}%`,
            top: `${node.y}%`,
            opacity: node.opacity,
            animation: `float-${(node.id % 3) + 1} ${node.duration}s ease-in-out ${node.delay}s infinite`,
          }}
        >
          {/* Inner dot */}
          <div 
            className="absolute top-1/2 left-1/2 w-1 h-1 bg-apple-blue rounded-full -translate-x-1/2 -translate-y-1/2"
          />
        </div>
      ))}
      
      {/* Connecting lines */}
      <svg className="absolute inset-0 w-full h-full opacity-10">
        {nodes.slice(0, -1).map((node, i) => {
          const nextNode = nodes[i + 1];
          return (
            <line
              key={`line-${i}`}
              x1={`${node.x}%`}
              y1={`${node.y}%`}
              x2={`${nextNode.x}%`}
              y2={`${nextNode.y}%`}
              stroke="#2997ff"
              strokeWidth="1"
              strokeDasharray="4 4"
            />
          );
        })}
      </svg>
    </div>
  );
};

export default FloatingNodes;
